import { createQueryHook } from '~/shared/providers/api';

export const useCustomerAccounts = createQueryHook(
  'trade.accounts',
  (params: {
    accountIds?: string[];
    searchTerm?: string;
    offset?: number;
    limit?: number;
  }) => ({
    accounts: {
      __args: {
        filter: {
          accountIds:
            params.accountIds?.length === 0
              ? ['invalid-id']
              : params.accountIds,
          searchTerm: params.searchTerm || undefined,
          isCustomer: true,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 50,
        },
        sorting: ['NameAsc'],
      },
      page: {
        __scalar: true,
      },
      entries: {
        id: true,
        name: true,
        type: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.accounts.entries.map((entry) => ({
        id: entry.id,
        name: entry.name,
        type: entry.type,
      })) ?? [],
  },
);
